import script from "./Installment.vue?vue&type=script&setup=true&lang=js"
export * from "./Installment.vue?vue&type=script&setup=true&lang=js"

import "./Installment.vue?vue&type=style&index=0&id=0188b9ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0188b9ec"]])

export default __exports__